import DraginoECComponent from "./add-device/dragino-ec-icon";
import DraginoGatewayComponent from "./add-device/dragino-gateway-icon";
import DualValveSeedComponent from "./add-device/dual-valve-seed-icon";
import SingleValveSeedComponent from "./add-device/single-valve-seed-icon";
import SproutBlockValveComponent from "./add-device/sprout-block-valve-icon";
import TensiometerComponent from "./dynamic-graph/tensiometer-icon";
import WatermarkComponent from "./dynamic-graph/watermark-icon";
import CropIconComponent from "./map-entity-base/crop-icon";
import MoistureSensorComponent from "./moisture-sensor-icon";
import PressureTransducerComponent from "./pressure-transducer-icon";
import InfoOutlineBlueComponent from "./sapling-verification/info-outline-blue-icon";
import SuccessOutlineComponent from "./sapling-verification/success-outlined-icon";
import {
    DoubleLeftArrow as DoubleLeftArrowComponent,
    DoubleRightArrow as DoubleRightArrowComponent,
    LeftArrow as LeftArrowComponent,
    RightArrow as RightArrowComponent,
} from "./schedule-editor/keyboard-arrows";
import WaterdropComponent from "./schedule-editor/waterdrop-icon";
import VarietalAvatarComponent from "./varietal-avatar";
import ZoneComponent from "./zone-icon";

export type InlineReactSVGComponent = React.FC<any>;

/**
 * React SVG icons defined as inline React components
 */

// used generally
export const Zone = ZoneComponent;
export const VarietalAvatar = VarietalAvatarComponent;
export const MoistureSensor = MoistureSensorComponent;
export const PressureTransducer = PressureTransducerComponent;

// Dec 2, 2025: Used only in the schedule-editor
export const DoubleLeftArrow = DoubleLeftArrowComponent;
export const DoubleRightArrow = DoubleRightArrowComponent;
export const LeftArrow = LeftArrowComponent;
export const RightArrow = RightArrowComponent;
export const Waterdrop = WaterdropComponent;

// Dec 2, 2025: Used only in the schedule-editor
export const InfoOutlineBlue = InfoOutlineBlueComponent;
export const SuccessOutline = SuccessOutlineComponent;

// Dec 2, 2025: Used only in the map-entity-base
export const Crop = CropIconComponent;

// Dec 2, 2025: Used only in the dynamic-graph
export const Tensiometer = TensiometerComponent;
export const Watermark = WatermarkComponent;

// Dec 2, 2025: Used only in the add-device flow
export const DualValveSeed = DualValveSeedComponent;
export const SingleValveSeed = SingleValveSeedComponent;
export const SproutBlockValve = SproutBlockValveComponent;
export const DraginoEC = DraginoECComponent;
export const DraginoGateway = DraginoGatewayComponent;
